module.exports = __webpack_public_path__ + "img/transact.d1f1a977.webp";